import axios from "axios";
import { setToast as Toast } from "../../../util/toast";
import { baseURL, secretKey as key } from "../../../util/config";
import {
  GET_AFFILIATE_WITHDRAWALS,
  APPROVE_AFFILIATE_WITHDRAWAL,
  REJECT_AFFILIATE_WITHDRAWAL,
  GET_AFFILIATE_WITHDRAWAL_STATS,
} from "./affiliateWithdraw.type";

export const getAffiliateWithdrawals = () => (dispatch) => {
  axios
    .get(`${baseURL}affiliateWithdrawRequest/all?key=${key}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_AFFILIATE_WITHDRAWALS, payload: res.data.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      Toast("error", error.message);
    });
};

export const approveAffiliateWithdrawal = (requestId) => (dispatch) => {
  axios
    .put(`${baseURL}affiliateWithdrawRequest/approve/${requestId}?key=${key}`)
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Withdrawal approved successfully!");
        dispatch(getAffiliateWithdrawals());
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      Toast("error", error.message);
    });
};

export const rejectAffiliateWithdrawal = (requestId, reason) => (dispatch) => {
  axios
    .put(`${baseURL}affiliateWithdrawRequest/reject/${requestId}?key=${key}`, { reason })
    .then((res) => {
      if (res.data.status) {
        Toast("success", "Withdrawal rejected!");
        dispatch(getAffiliateWithdrawals());
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      Toast("error", error.message);
    });
};

export const getAffiliateWithdrawalStats = () => (dispatch) => {
  axios
    .get(`${baseURL}affiliateWithdrawRequest/stats?key=${key}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_AFFILIATE_WITHDRAWAL_STATS, payload: res.data.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => {
      Toast("error", error.message);
    });
};